import { S1ProcessID } from "./s1-processid";
import { S1Process } from "./s1process.model";

export class SaveProcessRequest {
    id: S1ProcessID;
    processIn: S1Process;
    references: any;
}